import { Device } from '@swf/core/enums';
import type { ModelConfig, Slicer } from '@swf/core/store';

interface DeviceModel extends ModelConfig<Device> {
  selectors: typeof selectors;
  reducers: typeof reducers;
}

const reducers = {
  set: (state: Device, payload: { device: Device }) => payload.device
};

const selectors = (slice: Slicer<Device>) => ({
  get() {
    return slice;
  },
  getName() {
    return slice((device) => Device[device]);
  },
  isMobile() {
    return slice((device) => [Device.Phone, Device.Tablet].includes(device));
  },
  isPhone() {
    return slice((device) => device === Device.Phone);
  }
});

const device: DeviceModel = {
  state: Device.Unknown,
  reducers,
  selectors
};

export default device;
